export default __webpack_public_path__ + "static/media/delete.1854e3dd.svg";